import type { ComponentProps, FC, ReactNode } from "react";
import { useState } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Toolbar from "@mui/material/Toolbar";
import { MainMenu } from "../MainMenu/MainMenu";
import { AppBar } from "../AppBar/AppBar";

const DRAWER_WIDTH = 350;

export const Layout: FC<{
    children: ReactNode;
    appBar?: ComponentProps<typeof AppBar>;
    mainMenu?: ComponentProps<typeof MainMenu>;
    actionButton?: ComponentProps<typeof MainMenu>["actionButton"];
}> = ({ children, appBar, mainMenu, actionButton }) => {
    const [mobileOpen, setMobileOpen] = useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const drawer = (
        <div>
            <Toolbar />
            <MainMenu {...mainMenu} actionButton={actionButton} />
        </div>
    );

    const container =
        window !== undefined ? () => window.document.body : undefined;

    return (
        <Box sx={{ display: { xs: "block", sm: "flex" } }}>
            <AppBar
                iconButton={{ onClick: handleDrawerToggle }}
                accountMenu={appBar?.accountMenu}
            />
            <Box
                component="nav"
                sx={{
                    width: { sm: DRAWER_WIDTH },
                    flexShrink: { sm: 0 },
                }}
                aria-label="mailbox folders"
            >
                <Drawer
                    container={container}
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true,
                    }}
                    sx={{
                        display: { xs: "block", sm: "none" },
                        "& .MuiDrawer-paper": {
                            boxSizing: "border-box",
                            width: DRAWER_WIDTH,
                        },
                    }}
                >
                    {drawer}
                </Drawer>
                <Drawer
                    variant="permanent"
                    sx={{
                        display: { xs: "none", sm: "block" },
                        "& .MuiDrawer-paper": {
                            boxSizing: "border-box",
                            width: DRAWER_WIDTH,
                        },
                        height: "100%",
                    }}
                    open
                >
                    {drawer}
                </Drawer>
            </Box>
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    p: 3,
                    width: { sm: `calc(100% - ${DRAWER_WIDTH}px)` },
                }}
            >
                <Toolbar />
                {children}
            </Box>
        </Box>
    );
};

export default Layout;
